export const consignmentImageDefaultValues = {};
